var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('patch-dialog', { ref: "patchDialog", attrs: { "dialogConfig": _vm.dialogConfig, "visible": _vm.dialogConfig.visible, "uploaderType": _vm.uploaderType, "resourceType": _vm.resourceType }, on: { "update:visible": function updateVisible($event) {
        return _vm.$set(_vm.dialogConfig, "visible", $event);
      }, "submit": _vm.handleSubmit } });
};
var staticRenderFns = [];

export { render, staticRenderFns };